import React, {useEffect, ChangeEvent, FocusEvent} from 'react';
import {Checkbox} from "@eika/checkbox";
import {generateId} from '../util/Functions';
import {InputContent, StringObject} from '../../types';
import './FormInput.scss'

interface Props {
    content: InputContent;
    formAction: any;
    change: (e: ChangeEvent<HTMLInputElement>) => void;
    blur: (e: FocusEvent<HTMLInputElement>) => void;
}

export default (props: Props): React.ReactElement => {
    const {content, change, blur, formAction: {formState, register, setValue}} = props;
    const id = content.id || generateId('checkbox');
    const error = formState.errors[content.name];

    useEffect(() => {
        setValue(content.name, content.defaultValue);
    }, [content.defaultValue, content.name, setValue]);

    const attr: StringObject = [
        'required',
    ].reduce((pin: StringObject, key: string) => {
        // @ts-ignore
        if (content[key] !== undefined) {
            pin[key] = content[key as keyof unknown];
        }
        return pin;
    },
    {
        id,
        name: content.name,
        type: content.type,
        'aria-invalid': error?.message ? `${!!error?.message}` : '',
        'aria-controls': error?.message ? `${id}-error` : '',
    });

    Object.keys(attr).forEach((key: string) => {
        if (attr[key] === '') {
            delete (attr[key]);
        }
    });

    return <>
            {(content.list || []).map((data: any, i: number) => {

                return (
                    <Checkbox
                        className="center"
                        {...attr}
                        {...register(attr.name)}
                        id={`checkbox-${id}-${i}`}
                        key={`checkbox-${id}-${i}`}
                        value={data.value}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            change(e);
                        }}
                        onBlur={(e: FocusEvent<HTMLInputElement>) => {
                            blur(e);
                        }}
                        error={error?.message}
                        label={data.label}
                    />
                )
            })}
        </>
};
